module.exports = __webpack_public_path__ + "img/video_default.35e9340d.svg";